import { sortBy } from 'lodash-es';
import { createSelector } from 'redux-bundler';

export const selectAllBoardIDs = ({ boards }) => boards?.base?.allIDs || [];
export const selectBoardsById = ({ boards }) => boards?.base?.byId || {};
export const selectBoardsByOrganization = ({ boards }) =>
  boards?.byOrganization || {};

export const selectBoardIDsByCurrentOrganization = createSelector(
  'selectBoardsByOrganization',
  'selectCurrentOrganizationId',
  (boardsByOrganization, currentOrganizationId) =>
    boardsByOrganization?.[currentOrganizationId] || [],
);

// sort boards with data by archived last
export const selectBoardsSortedByArchived = createSelector(
  'selectBoardsById',
  'selectBoardIDsByCurrentOrganization',
  (boardsById, boardIDsByCurrentOrganization) => {
    const boards = Object.values(boardsById).filter((board) =>
      boardIDsByCurrentOrganization.includes(board.mongoId),
    );
    return sortBy(boards, [
      (boardId) => !boardId.active,
      (boardId) => boardId.name.toLowerCase(),
    ]);
  },
);

// number of active boards on an account
export const selectNumberOfBoards = createSelector(
  'selectBoardIDsByCurrentOrganization',
  (boardIDsByCurrentOrganization) => boardIDsByCurrentOrganization.length,
);

// number of active boards on an account
export const selectNumberOfActiveBoards = createSelector(
  'selectBoardIDsByCurrentOrganization',
  'selectBoardsById',
  (boardIDsByCurrentOrganization, boardsById) => {
    return boardIDsByCurrentOrganization.reduce((acc, boardId) => {
      const board = boardsById[boardId] || { active: false };
      return !board.active ? acc : acc + 1;
    }, 0);
  },
);
